import { i18nMark } from 'lingui-react';

const messages = {
  redirect: i18nMark('Redirecting...'),
};

export default messages;



// WEBPACK FOOTER //
// ./features/authentication/PortunusLogin/messages.js